import jQuery from "jquery";

jQuery( function( $ ) {
	'use strict';

	if ( 'undefined' === window.wcTracks ) {
		return;
	}

	var wc_bookings_tracks = {
		record_event: function( eventName, properties ) {
			const prefix = 'bookings_';

			let baseProperties = {
				bookings_version: wc_bookings_admin_js_params.bookings_version,
				bookings_db_version: wc_bookings_admin_js_params.bookings_db_version,
			};

			properties = { ...properties, ...baseProperties };

			const fullEventName = prefix + eventName;

			window.wcTracks.recordEvent( fullEventName, properties );
		},

		init: function() {
			var doc = $( document );

			doc.on( 'click', '.booking-calendar-booking-title, .booking-calendar-time-range', function() {
				wc_bookings_tracks.record_event( 'calendar_popover_clicked' );
			} );

			doc.on( 'click', '#wc-bookings-datepicker-toggle-day', function() {
				wc_bookings_tracks.record_event( 'calendar_datepicker_clicked' );
			} );

			doc.on( 'click', '.wc-bookings-datepicker-popover .CalendarDay', function() {
				wc_bookings_tracks.record_event( 'calendar_datepicker_date_changed' );
			} );

			doc.on( 'click', '.date-selector-popover .change-date.prev', function() {
				wc_bookings_tracks.record_event( 'calendar_change_date_prev_clicked' );
			} );

			doc.on( 'click', '.date-selector-popover .change-date.next', function() {
				wc_bookings_tracks.record_event( 'calendar_change_date_next_clicked' );
			} );

			doc.on( 'click', '.date-selector-popover .change-date.today', function() {
				wc_bookings_tracks.record_event( 'calendar_change_date_today_clicked' );
			} );

			doc.on( 'click', '.wc-bookings-calendar-popover #event_detail_footer a', function() {
				wc_bookings_tracks.record_event( 'calendar_popover_details_clicked' );
			} );

			doc.on( 'click', '#publish', function() {
				if ( -1 < window.location.href.indexOf( 'post-new.php' ) && 'booking' === $( '#product-type' ).val() ) {
					wc_bookings_tracks.record_event( 'booking_product_published' );
				}
			} );

			// Templates.
			doc.on( 'wc_bookings_template_clicked', function( event, templateIndex, templateSlug ) {
				wc_bookings_tracks.record_event(
					'template_click',
					{ product_template: templateSlug, source: window.pagenow || 'unknown' }
				);
			} );

			doc.on( 'click', '.bookings-templates a.start-from-scratch-link', function() {
				wc_bookings_tracks.record_event( 'template_click_blank' );
			} );


		}
	}
	wc_bookings_tracks.init();
} );
